import { Col, Row, Typography } from 'antd';
import { getDocumentNumber } from '../../../functions/getDocumentNumber';

type DocumentPreviewMetaProps = {
  studentName?: string;
  metaDataDate?: Date;
};

export const DocumentPreviewMeta = ({
  studentName = 'n a',
  metaDataDate = new Date(),
}: DocumentPreviewMetaProps) => {
  return (
    <Row>
      <Col span={12}>
        <Typography.Text type="secondary" style={{ fontSize: 'smaller' }}>
          {getDocumentNumber({
            nameSurname: studentName,
            date: metaDataDate,
          })}
        </Typography.Text>
      </Col>

      <Col span={12} style={{ textAlign: 'end' }}>
        <Typography.Text type="secondary" style={{ fontSize: 'smaller' }}>
          {metaDataDate.toLocaleString('lt')}
        </Typography.Text>
      </Col>
    </Row>
  );
};
